const WorkflowStepsPage = (): JSX.Element => {
    return (
      <>Workflow Steps</>
    )
  }
  
  export default WorkflowStepsPage